<script>
  let {
    children,
    /** @type {'top-right'|'inline-start'|'inline-end'} */
    placement = 'top-right'
  } = $props();
</script>

<div class='notification-badge text-control placement-{placement}'>
  {#if children}
    {@render children()}
  {/if}
</div>

<style lang='postcss'>
  .notification-badge {
    background-color: var(--editing);
    border-radius: var(--round);
    /* transform: translate(-50%, -50%); */
    color: var(--color-default-background);
    display: flex;
    place-content: center;
    place-items: center;
    line-height: 1;
    text-align: center;
    letter-spacing: 0;
    font-size: 8px;
    aspect-ratio: 1;
    width: 15px;
    height: 15px;
    &.placement-top-right {
      position: absolute;
      right: 0%;
      top: var(--size-1);
    }
    &.placement-inline-end {
      margin-inline-start: var(--size-2);
    }
    &.placement-inline-start {
      margin-inline-end: var(--size-2);
    }
  }
</style>